var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"worldmap"},[_c('div',{ref:"map",staticClass:"charts",style:({ height: _vm.eheight })})])
}
var staticRenderFns = []

export { render, staticRenderFns }